import { CommercialPerformerTypes } from '@shared/types';

type TRoleLike = { performer_type?: string | null };

/**
 * Whether a session activity's roles must be cleared because the session's commercial type
 * changed to one those roles can't perform in (e.g. TV → Radio drops on-camera roles).
 *
 * Only a real change counts: `previousType` is undefined the first time an activity row renders,
 * and treating that as a change used to save (or wipe the roles of) every activity just from
 * opening the page - each save then recalculating the whole estimate, a dozen identical saves at once.
 */
export const shouldClearRolesForCommercialType = (
  previousType: string | undefined,
  nextType: string | undefined,
  roles: TRoleLike[] | undefined
): boolean => {
  if (previousType === undefined || !nextType || previousType === nextType) return false;
  if (!roles?.length) return false;

  const allowed = CommercialPerformerTypes[nextType] ?? [];
  return roles.some((role) => !allowed.includes(role.performer_type as (typeof allowed)[number]));
};
